/* eslint-disable no-restricted-syntax */
import axios, { InternalAxiosRequestConfig } from 'axios';
import {
  env,
  Native,
} from '@hb/hbridge';
import Storage from './storage';
import Cookie from './cookie';
import appLoginModel from '@/models/appLoginModel';

let mobileInfo = {};

/**
 * 获取移动设备信息
 * @returns
 */
export const getMobileInfo = () => {
  if (Object.keys(mobileInfo).length) {
    return mobileInfo;
  }
  try {
    mobileInfo = {
      mobileVersion: 'UNKNOW',
      mobileModel: 'UNKNOW',
      mobileSystem: 'UNKNOW',
      systemPlatform: 'UNKNOW',
    };
    return mobileInfo;
  } catch (e) {
    return {
      mobileVersion: 'UNKNOW',
      mobileModel: 'UNKNOW',
      mobileSystem: 'UNKNOW',
      systemPlatform: 'UNKNOW',
    };
  }
};

/**
 * 获取请求基础参数
 * @returns
 */
export const getHttpBaseParams = async (params: any) => {
  const loginResult = (Storage?.getItem('login_result') || {}) as any;
  const userToken = Cookie?.getItem('user_token') || '';

  const getTokenAndTicket = async () => {
    if (env.isHelloPetApp) {
      const { token, ticket } = await appLoginModel.getLoginResult({ needLogin: params.needLogin || false });
      return {
        ticket,
        token,
      };
    }
    const {
      ticket = '',
      token = '',
    } = loginResult || {};
    return {
      ticket,
      token,
    };
  };

  const { token = '', ticket = '' } = await getTokenAndTicket();

  const {
    appVersion,
  } = env || {};

  const httpBaseParams = {
    ...(ticket ? {
      ticket,
    } : {}),
    ...(token || userToken ? {
      token: token || userToken,
    } : {}),
    ...getMobileInfo(),
    version: appVersion,
    systemCode: 'Mi3',
  };

  return httpBaseParams;
};

const service = axios.create({
  timeout: 150000,
  headers: {
    'content-type': 'application/json',
  },
});

const beforeRequest = async (value: InternalAxiosRequestConfig<any>) => {
  const {
    data,
    headers,
  } = value;

  const newData = {
    ...data,
    ...(await getHttpBaseParams(data) || {}),
  };

  const {
    isUploadFile,
  } = newData || {};

  if (isUploadFile) {
    Object.assign(value, {
      headers: {
        ...headers,
        'Content-Type': 'multipart/form-data',
      },
    });
    const formData = new FormData();
    delete newData.isUploadFile;

    for (const item in newData) {
      // eslint-disable-next-line no-prototype-builtins
      if (newData?.hasOwnProperty(item)) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        formData.append(item, newData[item]);
      }
    }
    Object.assign(value, {
      data: formData,
    });
  } else {
    Object.assign(value, {
      data: newData,
    });
  }

  return value;
};

service.interceptors.request.use(beforeRequest);

service.interceptors.response.use(
  (response: { data: any; }) => response.data,
  (error) => {
    console.log(error, 'response-error');
  },
);

export default service;
